/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

// import report
import MerchantTransaction from '../views/report/MerchantTransaction.vue';
import AggregatorTransaction from '../views/report/AggregatorTransaction.vue';
import CptsTransaction from '../views/report/CptsTransaction.vue';
import NfcTransaction from '../views/report/NfcTransaction.vue';

import { setBreadcrumb } from './index';

const reportRoute = {
  path: '/report',
  name: 'Report',
  children: [
    {
      path: '/report/cpts-transaction',
      meta: {
        title: 'BNI QRIS - CPTS Transaction',
        appBarTitle: 'CPTS Transaction',
        breadcrumbs: () => [
          setBreadcrumb('report', '/report', true),
          setBreadcrumb('cpts transaction', '/report/cpts-transaction'),
        ],
      },
      component: CptsTransaction,
      name: 'CptsTransaction',
    },
    {
      path: '/report/merchant-transaction',
      meta: {
        title: 'BNI QRIS - Merchant Transaction',
        appBarTitle: 'Merchant Transaction',
        breadcrumbs: () => [
          setBreadcrumb('report', '/report', true),
          setBreadcrumb('merchant transaction', '/report/merchant-transaction'),
        ],
      },
      component: MerchantTransaction,
      name: 'MerchantTransaction',
    },
    {
      path: '/report/merchant-transaction-ch',
      meta: {
        title: 'BNI QRIS - Merchant Transaction',
        appBarTitle: 'Merchant Transaction',
        breadcrumbs: () => [
          setBreadcrumb('report', '/report', true),
          setBreadcrumb(
            'merchant transaction',
            '/report/merchant-transaction-ch'
          ),
        ],
      },
      component: MerchantTransaction,
      name: 'MerchantTransactionCh',
    },
    {
      path: '/report/aggregator-transaction',
      meta: {
        title: 'BNI QRIS - Aggregator Transaction',
        appBarTitle: 'Aggregator Transaction',
        breadcrumbs: () => [
          setBreadcrumb('report', '/report', true),
          setBreadcrumb(
            'aggregator transaction',
            '/report/aggregator-transaction'
          ),
        ],
      },
      component: AggregatorTransaction,
      name: 'AggregatorTransaction',
    },
    {
      path: '/report/aggregator-transaction-ch',
      meta: {
        title: 'BNI QRIS - Aggregator Transaction',
        appBarTitle: 'Aggregator Transaction',
        breadcrumbs: () => [
          setBreadcrumb('report', '/report', true),
          setBreadcrumb(
            'aggregator transaction',
            '/report/aggregator-transaction-ch'
          ),
        ],
      },
      component: AggregatorTransaction,
      name: 'AggregatorTransactionCh',
    },
    {
      path: '/report/nfc-transaction',
      meta: {
        title: 'BNI QRIS - NFC Transaction',
        appBarTitle: 'NFC Transaction',
        breadcrumbs: () => [
          setBreadcrumb('report', '/report', true),
          setBreadcrumb(
            'nfc transaction',
            '/report/nfc-transaction'
          ),
        ],
      },
      component: NfcTransaction,
      name: 'NfcTransaction',
    },
  ],
  meta: {
    title: 'BNI QRIS - Report',
    appBarTitle: 'Report',
  },
  component: Parent,
};
export default reportRoute;
